import styled from "styled-components";

export const HelpText = styled.span`
  font-size: 12px;
  margin-top: 0.5rem;
`;
